// extracted by mini-css-extract-plugin
export default {"cls1":"ResetPasswordForm-FieldSet_cls1__FPCCk","cls2":"ResetPasswordForm-FieldSet_cls2__QtEl6 ResetPasswordForm-FieldSet_cls1__FPCCk"};